import { render, staticRenderFns } from "./RegisTransaction.vue?vue&type=template&id=3e88c0ff&scoped=true"
import script from "./RegisTransaction.vue?vue&type=script&lang=js"
export * from "./RegisTransaction.vue?vue&type=script&lang=js"
import style0 from "./RegisTransaction.vue?vue&type=style&index=0&id=3e88c0ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e88c0ff",
  null
  
)

export default component.exports